export default function (http) {
    return {
        queryWeekList (data){
            return http.json({
                url: '/timeTable/queryWeekList',
                data
            })
        },
        queryAllWeekList (data){
            return http.json({
                url: '/timeTable/queryAllWeekList',
                data
            })
        },
        querySchoolIds(data){
            return http.json({
                url: '/sku/timeTable/querySchoolIds',
                data
            })
        },

        delete(data) {
            return http.json({
                url: `/sku/timeTable/delete`,
                data
            })
        },


        queryListPage (data){
            return http.json({
                url: '/timeTable/queryListPage',
                data
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/week.js